import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const SHIVLING_CATEGORY_SLUG = "shivling";
const banners = [
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373644/1000457610.webp",
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373645/1000457609.webp",
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373646/1000457611_1.webp",
];
export default function ShivlingSection() {
  const [shivlingCategory, setShivlingCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);
  useEffect(() => {
    const fetchShivlingCategory = async () => {
      try {
        setLoadingCategories(true);
        const result = await getCategories();
        console.log("All Categories:", result);
        if (!result?.success) {
          setShivlingCategory(null);
          setSubcategories([]);
          return;
        }
        const categories = result?.data || [];
        const shivling = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            SHIVLING_CATEGORY_SLUG.toLowerCase(),
        );
        console.log("Shivling Category:", shivling);
        if (!shivling) {
          console.error("Shivling category not found");
          setShivlingCategory(null);
          setSubcategories([]);
          return;
        }
        setShivlingCategory(shivling);
        if (Array.isArray(shivling.subcategories)) {
          setSubcategories(shivling.subcategories);
        } else {
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${shivling.id}/subcategories`,
          );

          const subResult = await subResponse.json();

          console.log("Shivling Subcategories:", subResult);

          if (subResult?.success) {
            setSubcategories(subResult.data || []);
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error("Shivling Category API Error:", error);

        setShivlingCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchShivlingCategory();
  }, []);

  const fetchAllProducts = async (categoryId) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,

        page: 1,

        limit: 12,
      });

      console.log("All Shivling Products:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Shivling Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchProductsBySubcategory = async (subcategoryId) => {
    try {
      if (!shivlingCategory?.id || !subcategoryId) {
        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: shivlingCategory.id,

        subcategoryId: subcategoryId,

        page: 1,

        limit: 12,
      });

      console.log("Shivling Products By Subcategory:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Shivling Subcategory Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (shivlingCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(shivlingCategory.id);
    }
  }, [shivlingCategory]);

  const handleSubcategoryClick = (subcategory) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(subcategory.id);

    fetchProductsBySubcategory(subcategory.id);
  };

  const handleAllClick = () => {
    if (!shivlingCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(shivlingCategory.id);
  };

  return (
    <section className="rudraksha-section">
      <div className="container">
        <div className="section-top">
          <h2>Buy Original Shivling Collection</h2>

          <div className="tabs">
            {/* ALL SHIVLING */}

            <button
              type="button"
              className={activeSubcategory === null ? "active" : ""}
              onClick={handleAllClick}
              disabled={loadingCategories || !shivlingCategory}
            >
              All Shivling
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map((subcategory) => (
                <button
                  type="button"
                  key={subcategory.id}
                  className={
                    activeSubcategory === subcategory.id ? "active" : ""
                  }
                  onClick={() => handleSubcategoryClick(subcategory)}
                >
                  {subcategory.name}
                </button>
              ))}
          </div>
        </div>

        <div className="section-content">
          <div className="left-banner">
            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {banners.map((image, index) => (
                <SwiperSlide key={index}>
                  <img src={image} alt="Shivling" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="right-products">
            {loadingCategories || loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Shivling products..." size={56} />
              </div>
            ) : products.length === 0 ? (
              <div className="loading">No Shivling products found</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={products.length > 3}
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >
                {products.map((product) => (
                  <SwiperSlide key={product.id}>
                    <ProductCard product={product} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
